import React from "react";
import PropTypes from "prop-types";
import Radio from "@mui/material/Radio";
import StyledRadioIcon from "../StyledRadio/StyledRadioIcon/StyledRadioIcon";
import StyledRadioChecked from "../StyledRadio/StyledRadioChecked/StyledRadioChecked";

export default function StandAloneRadio({checked, value, onChange, disabled}) {
  return (
    <Radio
      sx={{
        "&:hover": {
          bgcolor: "transparent",
        },
      }}
      disableRipple
      checkedIcon={<StyledRadioChecked />}
      icon={<StyledRadioIcon />}
      checked={checked}
      onChange={onChange}
      value={value}
      disabled={disabled}
    />
  );
}

StandAloneRadio.propTypes = {
  checked: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};